import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const NotificationsPage = lazy(() => import("./NotificationsPage"));

const NotificationsPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <NotificationsPage />
    </Suspense>
  );
};

export default NotificationsPageLazy;
